import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Col, Tooltip } from 'reactstrap';
import { AvForm } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';

import { FRONT_END_URL } from '../../../utils/Constants';
import { getCroppedImg, createFileFromBase64ImageData } from '../../../utils/CropImageUtils';
import { deletePromotionImage } from '../../../actions/index';

import CropImageModal from '../../common/CropImageModal';

class PromotionImageScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            imagePath: null,
            imagePreview: this.props.selectedPromotion.imagePreview ? this.props.selectedPromotion.imagePreview : null,
            imageFormData: null,
            cropPromotionImageModalOpened: false,
            promotionImageBase64: null,
            imageExtension: null,
            showDeleteImageTooltip: false,
        }
    }

    componentWillUnmount() {
        // Send the updated state data to the parent component
        this.props.getPageData(this.state);
    }

    componentDidUpdate(prevProps) {
        if (this.props.selectedPromotion.imagePath !== this.state.imagePath && this.props.selectedPromotion.id !== -1) {
            this.setState({
                imagePath: this.props.selectedPromotion.imagePath,
                imagePreview: this.props.selectedPromotion.imagePreview
            });
        }
    }

    submitForm() {
        // if valid calls onGoToNextPage if not dont call it
        let validFormData = true;

        if (validFormData) {
            this.props.goToNextPage();
            // Wait until the state of the component is send to the parent component before reset it
            setTimeout(() => {
                this.resetLocalState();
            }, 800);
        }
    }

    resetLocalState() {
        this.state.imagePath = null;
        this.state.imagePreview = null;
        this.state.imageFormData = null;
    }

    uploadImage(event) {
        event.preventDefault();
        const file = event.target.files[0];

        if (file.size > 512000) {
            this.props.dispatchErrorMessage(`${i18n.t('common:validations.maximumImageSize')} 512KB`)
        } else {
            if (file !== undefined) {                           // file === undefined when you click cancel
                this.setState({
                    ...this.state,
                    imagePreview: URL.createObjectURL(file),
                    imageFormData: event.target.files[0]
                });

                //this is for crop image
                let reader = new FileReader();

                reader.onloadend = () => {
                    this.setState({
                        ...this.state,
                        promotionImageBase64: reader.result,
                        imageExtension: file.type
                    }, () => this.togglePromotionImageCropModal());
                };
                reader.readAsDataURL(file);
            }
        }
    }

    togglePromotionImageCropModal = () => {
        this.setState({
            ...this.state,
            cropPromotionImageModalOpened: !this.state.cropPromotionImageModalOpened
        });
    }

    onCropPromotionImageUpload = async (crop) => {
        try {
            const imageData = await getCroppedImg(crop.image, crop.croppedAreaPixels, 0, this.state.imageExtension);
            const blobData = createFileFromBase64ImageData(imageData, this.state.imageExtension);
            const uploadImageExtension = this.state.imageExtension.split('/')[1];
            const imageFile = new File([blobData], `promotionImage.${uploadImageExtension}`, { type: blobData.type });

            this.setState({
                ...this.state,
                imagePreview: imageData,
                imageFormData: imageFile
            }, () => this.togglePromotionImageCropModal());
        } catch (e) {
            console.error(e);
        }
    }

    toggleDeleteImageTooltip() {
        this.setState({ ...this.state, showDeleteImageTooltip: !this.state.showDeleteImageTooltip });
    }

    deleteImage = () => {
        console.log(this.state, 'states')
        if(this.state.imagePreview !== null && this.state.imagePreview !== undefined || this.state.imagePath !== null && this.state.imagePath !== undefined) {
            this.props.deletePromotionImage(this.props.selectedPromotion.id);
            this.setState({ imagePreview: null })
            this.props.selectedPromotion.imagePath = null;
        }
    }

    render() {
        const { formContainer, figure, headerCol, headerP } = styles;
        const { imagePreview, imagePath } = this.state;

        if (this.props.requestTabChange) {
            this.submitForm();
        }

        let imageSrc;
        let labelStyle;
        let imgStyle;

        if (imagePreview !== null && imagePreview !== undefined) {
            imageSrc = imagePreview;
            labelStyle = '';
            imgStyle = { width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 };
        } else if (imagePath === null) {
            imageSrc = imagePreview;
            labelStyle = 'coloured-label'
            imgStyle = { height: '100%', objectFit: 'cover', zIndex: 1 };
        } else {
            imageSrc = `${FRONT_END_URL}/${imagePath}`;
            labelStyle = '';
            imgStyle = { width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 }
        }

        const imageHeader = {
            noImage: i18n.t('screens:promotionImageScreen.noImg'),
            changeImage: i18n.t('screens:promotionImageScreen.changeImg')
        }

        return (
            <Fragment>
                <AvForm style={formContainer}>
                    <Col sm={12} style={headerCol}>
                        <p style={headerP}>{imagePreview === null && imagePath === null ? imageHeader.noImage : imageHeader.changeImage}</p>
                    </Col>
                    <Col style={{ display: 'flex', justifyContent: 'center', paddingLeft: '60px'}}>
                        <figure style={figure}>
                            <input id="imagePreview" value={''} className="custom-file-input" type="file" name="imagePreview" onChange={(event) => this.uploadImage(event)} />
                            <label className={labelStyle} style={{ width: '26%', left: '53.5%' }} for="imagePreview">
                                <div style={{ display: 'flex', flexFlow: 'row wrap', justifyContent: 'center', textAlign: 'center' }}>
                                    <span><MaterialIcon icon="local_see" size={30} /></span>
                                    {i18n.t('common:buttons.fileUpload')}
                                    <div style={{ fontSize: 12 }}>({i18n.t('screens:promotionImageScreen.specs')})</div>
                                </div>
                            </label>
                            <img style={imgStyle} src={imageSrc} />
                        </figure>
                        <div id='deleteProductImageButton' style={{ marginRight: 10 }}>
                            <span style={{ cursor: 'pointer' }} onClick={this.deleteImage}>
                                <MaterialIcon icon="delete_outline" color="#cdcdcd" size={26} />
                            </span>
                        </div>
                        {
                        this.state.imagePath !== null && this.state.imagePath !== undefined || this.state.imagePreview !== null && this.state.imagePreview !== undefined ?
                            <Tooltip disabled={false} placement="top" isOpen={this.state.showDeleteImageTooltip} target="deleteProductImageButton" toggle={this.toggleDeleteImageTooltip.bind(this)}>
                                {i18n.t('screens:productScreen.deleteImg')}
                            </Tooltip> : null
                        }
                    </Col>
                </AvForm>
                {
                    this.state.cropPromotionImageModalOpened ?
                        <CropImageModal
                            isOpen={this.state.cropPromotionImageModalOpened}
                            onClickSave={this.onCropPromotionImageUpload}
                            toggle={this.togglePromotionImageCropModal}
                            modalClass='cropPromotionImage'
                            crop={{
                                image: this.state.promotionImageBase64,
                                crop: { x: 0, y: 0 },
                                zoom: 1,
                                cropSize: { width: 300, height: 225 },
                                croppedAreaPixels: null,
                            }}
                        /> : null
                }
            </Fragment>
        );
    }
}

export default connect(null, {
   deletePromotionImage,
})(PromotionImageScreen);

const styles = {
    formContainer: {
        marginTop: 20,
        height: 300,
        overflowX: 'hidden',
        overflowY: 'hidden',
        backgroundColor: '#f8f8f8',
        border: '1px solid #E9ECEF'
    },
    figure: {
        display: 'flex',
        alignItems: 'center',
        height: 225,
        width: 300,
        overflow: 'hidden',
        background: '#F0F0F0'
    },
    headerCol: {
        paddingTop: 10,
        paddingBottom: 10,
        backgroundColor: '#f8f8f8'
    },
    headerP: {
        margin: 0,
        textAlign: 'center'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/promotions/PromotionImageScreen.js